/**
 * Product page elements
 */
class ME_Product {
    constructor() {
        this.initOpenExpandableProductContent();
        this.initOpenExpandableProductList();
        this.initOpenMaterialTools();
        this.initPricesShowMore();
        this.initTeacherShowMore();
        this.initProductPanelLevel();
        this.initProductNavigation();
        this.initProductGallery();
    }

    initOpenExpandableProductContent() {
        let btnExpandalbe = $('.product-content-sections-wrapper__button');
        let productContentExpandable = $('.product-content-sections-wrapper--expandable');

        if (!btnExpandalbe.length) {
            return;
        }

        btnExpandalbe.on('click', e => {
            e.preventDefault()
            productContentExpandable.addClass('active');
            $(this).closest('#main').find('.hide-description-section').removeClass('hidden');
            $(this).remove();
        })
    }

    initOpenExpandableProductList() {
        let btnExpandableList = $('.product-default__show-more');

        if (!btnExpandableList.length) {
            return;
        }

        btnExpandableList.on('click', (e) => {
            e.preventDefault();
            $(e.target).parents('.product-default-component__content').find('.product-expandable-list').addClass('active');
            $(e.target).remove();
        })
    }

    initOpenMaterialTools() {
        let btnOpenMaterialTools = $('.product-material-tools__table__show-more-trigger');

        if (!btnOpenMaterialTools.length) {
            return;
        }

        btnOpenMaterialTools.on('click', (e) => {
            e.preventDefault();
            $(e.target).prev('.product-material-tools__table').addClass('active');
            $(e.target).remove();
        });
    }

    initPricesShowMore() {
        let btnProductConponentsShowMore = $('.product-components__show-more');

        if (!btnProductConponentsShowMore.length) {
            return;
        }

        btnProductConponentsShowMore.on('click', (e) => {
            e.preventDefault();
            $('.product-components__table').addClass('active');
            $(e.target).remove();

            setTimeout(() => {
                $('.product-components__table').addClass('visible')
            })
        })
    }

    initPricesShowMore() {
        let btnPricesShowMore = $('.product-prices__show-more');

        if (!btnPricesShowMore.length) {
            return;
        }

        btnPricesShowMore.on('click', (e) => {
            e.preventDefault();
            $('.product-prices').addClass('active');
            $(e.target).remove();
        })
    }

    initTeacherShowMore() {
        let btnTeacherShowMore = $('.product-teacher__show-more');

        if (!btnTeacherShowMore.length) {
            return;
        }

        btnTeacherShowMore.on('click', (e) => {
            e.preventDefault();
            $(e.target).parent().addClass('active');
            $(e.target).remove();
        })
    }

    initProductPanelLevel() {
        $('ul.product-panel__levels li').click((e) => {
            let level_index = $(e.target).data('level');

            $('ul.product-panel__levels li').removeClass('active');
            $('ul.product-panel__levels li[data-level="' + level_index + '"]').addClass('active');

            $('.level-p').addClass('hidden');
            $('.level-p.level-p-' + level_index).removeClass('hidden');

            $('.row_level').addClass('hidden');
            $('.row_level_' + (level_index)).removeClass('hidden');

        });
    }

    initProductNavigation() {
        let nav = $('.section-product-navigation');
        let navWrapper = $('.product-navigation-wrapper');
        let header = $('#top');
        let navItems = nav.find('.product-navigation__list');

        $(window).on('scroll', () => {
            let headerPosition = $(window).scrollTop();

            $('.product-navigation-section').each(function () {
                if (headerPosition > $(this).offset().top - 250 && headerPosition < $(this).offset().top + $(this).outerHeight()) {
                    var activeItem = navItems.find('a[href="#' + $(this).attr('id') + '"]').parent()
                    activeItem.addClass('active')
                    activeItem.siblings().removeClass('active')
                }
            })
        })

        $(window).on('load', () => {
            setTimeout(() => {
                $(window).scroll()
            }, 250)
        })

        // Open mobile nav list
        $('.product-navigation__list-open').on('click', (e) => {
            e.preventDefault();
            let navItemsLi = navItems.find('.product-navigation__item');
            nav.toggleClass('open-mobile-nav');

            for (let i = 0; i < navItemsLi.length; i++) {
                navItemsLi.removeClass('active');
            }
        });

        // Close mobile nav list
        $("body").on('click', function () {
            nav.removeClass('open-mobile-nav');
        });

        $(".section-product-navigation").on('click', function (e) {
            e.stopPropagation();
        });

        $('.product-navigation__list-close').on('click', function (e) {
            e.preventDefault();
            nav.removeClass('open-mobile-nav');
        });

        // Product Scroll
        $('.product-scroll').on('click', (e) => {
            e.preventDefault();
            let link = $(e.target);
            let el = $(link.attr('href'));
            let navTopStyle = navWrapper.css('top');
            let navTopStylePosition = parseInt(navTopStyle.substring(0, navTopStyle.length - 1))
            let top = el.offset().top - navTopStylePosition - 120;
            nav.removeClass('open-mobile-nav');
        });
    }

    initProductGallery () {
        $('.product-panel__gallery__thumbnail--image').on('click', function (e) {
            e.preventDefault()
            $(this).siblings().removeClass('active');
            $(this).addClass('active');
            let imageNumber = $(this).attr('data-product-thumbnail');

            $('.product-panel__gallery__image').css('transform', 'translate(-' + imageNumber*100 + '%, 0)' );
        });
    }
}
